import React, { Component } from 'react'
import { CardHeader, ContactCard, Modal, Card, TextInput } from 'advenio-components'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import PropTypes from 'prop-types'
import { path } from 'ramda'
import moment from 'moment'
import styled from 'styled-components'
import GoToButton from '../CustomButtons/GoToButton'
import BrotherButton from '../CustomButtons/BrotherButton'
import ProfilePanelMobile from './ProfilePanelMobile'
import ClassroomActions, { Selectors } from '../../Data/Redux/ClassroomRedux'
import LoadingSpinner from '../../Components/LoadingSpinner'
import AddSibling from '../ModalContainer/AddSibling'
import AddParent from '../ModalContainer/AddParent'
import ImageUploader from 'react-images-upload'
import {
  PanelContainer,
  PanelHeader,
  PanelSection,
  ProfilePicture,
  ProfileIcon,
  ProfilePictureContent,
  PillsRow,
  Pills,
  InventorySection,
  InventoryRow,
  DivWithIcon,
  StyledSpan,
  DesktopContainer,
  MobileContainer,
  Container,
  CloudBar,
  CloudIcon,
} from './ProfilePanel.styles'
import StatusBar from './StatusBar'
import { userHasRole } from '../../utils/Utils'

const Icon = styled.img`
  width: 14px;
  height: 14px;
  margin-right: 4px;
  cursor: pointer;
`
const PageContainer = styled(Card)`
  margin-left: 16px;
  margin-right: 8px;
`
const PageContainerMobile = styled.div`
  @media (max-width:767px) {
    background-color: white;
    width: 100%;
    margin:0;
  }
`
// const paola = (props, state) =>{KC}
class ProfilePanel extends Component {
  state = {
    addSibling: false,
    addParent: false,
  };

  getInfoPill = () => {
    const { classrooms, student, studyPrograms } = this.props;

    if (classrooms.length <= 0 || studyPrograms.length <= 0) {
      return {};
    }

    const [classroom] = this.props.classrooms.filter(
      (cls) => cls.id === student.classroom_id
    );
    const [studyProgram] = this.props.studyPrograms.filter(
      (sp) => sp.id === student.study_program_id
    );
    const info = {};

    if (classroom) {
      info.classroom = classroom.name;
    }
    if (studyProgram) {
      info.studyProgram = studyProgram.name;
    }
    if (student.center) {
      info.center = student.center.abbreviation;
    }

    return info;
  };

  getRelation = (relation_id) => {
    const relation = this.props.relations.find((rel) => rel.id === relation_id);
    return relation ? relation.translations.es : "";
  };

  getCompanyName = (id) => {
    const company = this.props.companies.find((c) => c.id === Number(id));
    // if(company ===  undefined){
    //   return ''
    // }
    return company.name;
  };

  sendToProfile = (sibling) => {
    const { goTo, setActiveStudentId, user, centroclassroom } = this.props;
    let centro = null;

    user.role === "Back Office Admin"
      ? (centro = centroclassroom)
      : (centro = user.centro_id);
    if (centro === sibling.center.id) {
      setActiveStudentId(Number(sibling.id));
      goTo(`/classroom/${sibling.classroom_id}/student/${sibling.id}`);
    } else if (user.role === "Back Office Admin") {
      setActiveStudentId(Number(sibling.id));
      goTo(`/classroom/${sibling.classroom_id}/student/${sibling.id}`);
      window.location.reload();
    }
  };

  addSibling = () => this.setState({ addSibling: true });

  toggleAddParent = (status) => this.setState({ addParent: status === "open" });

  closeModal = () => this.setState({ addSibling: false });

  inCenter = (sibling) =>
    this.props.classrooms.find((classroom) =>
      classroom.id === sibling.classroom_id ? classroom : classroom
    );

  formatHoursConsumed = (time = "") => {
    const [hours, minutes] = time.split(":");

    return `${hours}h ${minutes}m`;
  };

  onDrop = () => {

    const { updateStudent, student, activeStudentId } = this.props
    const [fileInput] = document.getElementsByName('profile');
    const file = fileInput.files[0]

    let payload = {
      support_as_pct: Boolean(student.support_as_pct),
    }


    if (file) {
      const fileReader = new FileReader();

      fileReader.addEventListener("load", ({ target: { result } }) => {


        payload = {
          ...payload,
          profile_pic: result
        }

        updateStudent(activeStudentId, payload, student.updated_at)


      });

      fileReader.readAsDataURL(file);
    }
  };




  renderSections = () => {
    const {
      isDisenrolled,
      onCheckIn,
      onCheckOut,
      onHealthCheck,
      onParentClick,
      onReportClick,
      student,
      teacher,
      user,
    } = this.props;

    if (isDisenrolled) {
      return (
        <div>
          <PanelSection top>
            <PanelHeader>PAPÁS</PanelHeader>
            {student.parents.map((parent) => (
              <ContactCard
                name={`${parent.first_name || ""} ${parent.last_name_paternal || ""
                  } ${parent.last_name_maternal || ""}`}
                key={parent.first_name}
                role={!teacher ? this.getRelation(parent.relation_id) : ""}
                userId={parent.userable_id || parent.id}
                email={!teacher ? parent.email : ""}
                phone={!userHasRole(user, "Teacher") ? parent.phone : ""}
                onClick={!teacher ? onParentClick : () => null}
                withoutArrow={teacher}
              />
            ))}
            {student.parents.length < 2 && (
              <GoToButton
                normal
                icon="/assets/plus.svg"
                label="Agregar tutor..."
                onButtonClick={() => this.toggleAddParent("open")}
              />
            )}
          </PanelSection>
          {userHasRole(user, [
            "Director",
            "Coordinator",
            "Back Office Admin",
          ]) && (
              <PanelSection top>
                <PanelHeader>HERMANOS</PanelHeader>
                {student.siblings.map((sibling) => (
                  <BrotherButton
                    key={`CheckOutsSibling${sibling.id}`}
                    onClick={() => this.sendToProfile(sibling)}
                    inCenter={this.inCenter(sibling)}
                    {...sibling}
                  />
                ))}
                <GoToButton
                  normal
                  icon="/assets/plus.svg"
                  label="Agregar hermano..."
                  onButtonClick={this.addSibling}
                />
              </PanelSection>
            )}
        </div>
      );
    }

    // Student is checked out
    if (
      !path(["checkin", "id"], student) &&
      student.parents &&
      student.siblings
    ) {
      return (
        <div>

          {/* <ImageUploader
            withIcon={false}
            buttonText="Eligir Imagen"
            onChange={this.onDrop}
            imgExtension={[".jpg", ".gif", ".png",".jpeg"]}
            // maxFileSize={5242880}
            withPreview
            label=""
            fileSizeError="La imágen excede los 5mb"
            fileTypeError="Extención del archivo no soportada."
            singleImage
          />   */}
          <PanelSection top>
            <PanelHeader>INFORMACIÓN</PanelHeader>
            <InventoryRow>
              <DivWithIcon>
                <Icon src="/assets/office.svg" alt="clock" />
                <StyledSpan>Empresa y Convenio</StyledSpan>
              </DivWithIcon>
              <StyledSpan right>
                {student.product.type === "ContractProduct"
                  ? `${this.getCompanyName(
                    student.product.contract.company_id
                  )}::${student.product.contract.name}`
                  : "Sin Convenio"}
              </StyledSpan>
            </InventoryRow>
            <InventoryRow>
              <DivWithIcon>
                <Icon src="/assets/cake.svg" alt="diaper" />
                <StyledSpan>Fecha de Nacimiento</StyledSpan>
              </DivWithIcon>
              <StyledSpan right>
                {student.birth_date &&
                  moment(student.birth_date).format("DD MMM YYYY")}
              </StyledSpan>
            </InventoryRow>
            <InventoryRow>
              <DivWithIcon>
                <Icon src="/assets/people_icon.svg" alt="clock" />
                <StyledSpan>Fecha de Iniciación</StyledSpan>
              </DivWithIcon>
              <StyledSpan right>
                {student.first_enrollment &&
                  moment(student.first_enrollment).format("DD MMM YYYY")}
              </StyledSpan>
            </InventoryRow>
            <InventoryRow>
              <DivWithIcon>
                <Icon src="/assets/info_icon.svg" alt="clock" />
                <StyledSpan>Producto</StyledSpan>
              </DivWithIcon>
              <StyledSpan>
                {student.product.product_details.product.name}
              </StyledSpan>
            </InventoryRow>
            {student.product.hours_consumed &&
              student.product.hours_consumed !== null && (
                <InventoryRow>
                  <DivWithIcon>
                    <Icon src="/assets/clock_icon.svg" alt="hours" />
                    <StyledSpan>Horas Consumidas</StyledSpan>
                  </DivWithIcon>
                  <StyledSpan>
                    {this.formatHoursConsumed(student.product.hours_consumed)}
                  </StyledSpan>
                </InventoryRow>
              )}
            {student.product.product_details &&
              student.product.product_details.product_id === 16 && (
                <InventoryRow>
                  <DivWithIcon>
                    <Icon src="/assets/clock_icon.svg" alt="hours" />
                    <StyledSpan>Limite de Horas</StyledSpan>
                  </DivWithIcon>
                  <StyledSpan>
                    {this.formatHoursConsumed(student.daycare_limit)}
                  </StyledSpan>
                </InventoryRow>
              )}
          </PanelSection>

          <PanelSection top>
            <PanelHeader>PAPÁS</PanelHeader>
            {student.parents.map((parent) => (
              <ContactCard
                name={`${parent.first_name || ""} ${parent.last_name_paternal || ""
                  } ${parent.last_name_maternal || ""}`}
                key={parent.first_name}
                role={!teacher ? this.getRelation(parent.relation_id) : ""}
                userId={parent.userable_id || parent.id}
                email={!teacher ? parent.email : ""}
                email_institutional={!teacher ? parent.email_institutional : ""}
                phone={!userHasRole(user, "Teacher") ? parent.phone : ""}
                onClick={!teacher ? onParentClick : () => null}
                withoutArrow={teacher}
              />
            ))}

            {student.parents.length < 2 && (
              <GoToButton
                normal
                icon="/assets/plus.svg"
                label="Agregar tutor..."
                onButtonClick={() => this.toggleAddParent("open")}
              />
            )}
          </PanelSection>
          {userHasRole(user, [
            "Director",
            "Coordinator",
            "Back Office Admin",
            "Receptionist",
          ]) && (
              <PanelSection top>
                <PanelHeader>HERMANOS</PanelHeader>
                {student.siblings.map((sibling) => (
                  <BrotherButton
                    key={`CheckOutsSibling${sibling.id}`}
                    onClick={() => this.sendToProfile(sibling)}
                    inCenter={this.inCenter(sibling)}
                    {...sibling}
                  />
                ))}
                <GoToButton
                  normal
                  icon="/assets/plus.svg"
                  label="Agregar hermano..."
                  onButtonClick={this.addSibling}
                />
              </PanelSection>
            )}
          {/* {!userHasRole(user, 'Teacher') && ( */}
          <PanelSection top>
            <GoToButton
              icon="/assets/blue_check_out_icon.svg"
              label="Check In"
              onButtonClick={onHealthCheck}
            />
          </PanelSection>
          {/* )} */}
        </div>
      );
    } else if (student.parents && student.siblings) {
      return (
        <div>
          <PanelSection top>
            <PanelHeader>INFORMACIÓN</PanelHeader>
            <InventoryRow>
              <DivWithIcon>
                <Icon src="/assets/office.svg" alt="clock" />
                <StyledSpan>Empresa y Convenio</StyledSpan>
              </DivWithIcon>
              <StyledSpan right>
                {student.product.type === "ContractProduct"
                  ? `${this.getCompanyName(
                    student.product.contract.company_id
                  )}::${student.product.contract.name}`
                  : "Sin Convenio"}
              </StyledSpan>
            </InventoryRow>
            <InventoryRow>
              <DivWithIcon>
                <Icon src="/assets/cake.svg" alt="diaper" />
                <StyledSpan>Fecha de Nacimiento</StyledSpan>
              </DivWithIcon>
              <StyledSpan right>
                {student.birth_date &&
                  moment(student.birth_date).format("DD MMM YYYY")}
              </StyledSpan>
            </InventoryRow>
            <InventoryRow>
              <DivWithIcon>
                <Icon src="/assets/people_icon.svg" alt="clock" />
                <StyledSpan>Fecha de Iniciación</StyledSpan>
              </DivWithIcon>
              <StyledSpan right>
                {student.first_enrollment &&
                  moment(student.first_enrollment).format("DD MMM YYYY")}
              </StyledSpan>
            </InventoryRow>
            <InventoryRow>
              <DivWithIcon>
                <Icon src="/assets/info_icon.svg" alt="clock" />
                <StyledSpan>Producto</StyledSpan>
              </DivWithIcon>
              <StyledSpan>
                {student.product.type === "ContractProduct"
                  ? student.product.contract.contract_type
                  : student.product.product_details.product.name}
              </StyledSpan>
            </InventoryRow>
            {student.product.hours_consumed &&
              student.product.hours_consumed !== null && (
                <InventoryRow>
                  <DivWithIcon>
                    <Icon src="/assets/clock_icon.svg" alt="hours" />
                    <StyledSpan>Horas Consumidas</StyledSpan>
                  </DivWithIcon>
                  <StyledSpan>
                    {this.formatHoursConsumed(student.product.hours_consumed)}
                  </StyledSpan>
                </InventoryRow>
              )}
            {student.product.product_details &&
              student.product.product_details.product_id === 16 && (
                <InventoryRow>
                  <DivWithIcon>
                    <Icon src="/assets/clock_icon.svg" alt="hours" />
                    <StyledSpan>Limite de Horas</StyledSpan>
                  </DivWithIcon>
                  <StyledSpan>
                    {this.formatHoursConsumed(student.daycare_limit)}
                  </StyledSpan>
                </InventoryRow>
              )}
          </PanelSection>
          <PanelSection top>
            <PanelHeader>PAPÁS</PanelHeader>
            {student.parents.map((parent) => (
              <ContactCard
                name={`${parent.first_name || ""}
                ${parent.last_name_paternal || ""}
                ${parent.last_name_maternal || ""}`}
                key={parent.first_name}
                role={!teacher ? this.getRelation(parent.relation_id) : ""}
                userId={parent.userable_id || parent.id}
                email={!teacher ? parent.email : ""}
                phone={!teacher ? parent.phone : ""}
                onClick={!teacher ? onParentClick : () => null}
                withoutArrow={false}
              />
            ))}

            {student.parents.length < 2 && (
              <GoToButton
                normal
                icon="/assets/plus.svg"
                label="Agregar tutor..."
                onButtonClick={() => this.toggleAddParent("open")}
              />
            )}
          </PanelSection>
          {userHasRole(user, [
            "Director",
            "Coordinator",
            "Back Office Admin",
            "Receptionist",
          ]) && (
              <PanelSection top>
                <PanelHeader>HERMANOS</PanelHeader>
                {student.siblings.map((sibling) => (
                  <BrotherButton
                    key={`Sibling${sibling.id}`}
                    inCenter={this.inCenter(sibling)}
                    onClick={() => this.sendToProfile(sibling)}
                    {...sibling}
                  />
                ))}
                <GoToButton
                  normal
                  icon="/assets/plus.svg"
                  label="Agregar hermano..."
                  onButtonClick={this.addSibling}
                />
              </PanelSection>
            )}
          <PanelSection top>
            <GoToButton
              icon="/assets/greenCheckIn.svg"
              label="Formato de entrada"
              onButtonClick={onCheckIn}
            />
            <GoToButton
              icon="/assets/red_daily_eval.svg"
              label="Agregar valoracion diaria"
              onButtonClick={onHealthCheck}
            />
            <GoToButton
              icon="/assets/yellow_issue_report.svg"
              label="Reportar incidente"
              onButtonClick={onReportClick}
            />
            <GoToButton
              icon="/assets/blue_check_out_icon.svg"
              label="Check Out"
              onButtonClick={onCheckOut}
            />
          </PanelSection>
        </div>
      );
    }

    return (
      <PanelSection>
        <GoToButton
          icon="/assets/greenCheckIn.svg"
          label="Formato de entrada"
          onButtonClick={onCheckIn}
        />
        <GoToButton
          icon="/assets/red_daily_eval.svg"
          label="Agregar valoracion diaria"
          onButtonClick={onHealthCheck}
        />
        <GoToButton
          icon="/assets/yellow_issue_report.svg"
          label="Reportar incidente"
          onButtonClick={onReportClick}
        />
        <GoToButton
          icon="/assets/blue_check_out_icon.svg"
          label="Check Out"
          onButtonClick={onCheckOut}
        />
      </PanelSection>
    );
  };

  render() {
    const { addingSibling, student, loading, studentProfile } = this.props;
    const { addSibling } = this.state;
    const infoPills = this.getInfoPill();

    return (
      <Container>
        {loading ? (
          <PageContainer>
            <Modal isOpened loading />
          </PageContainer>
        ) : (
          <DesktopContainer>
            <PanelContainer>
              <CardHeader>
                <ProfilePictureContent>
                  <div
                    // style={{ background: '#9F9F9F' }}
                    onClick={() => {
                      var [input] = document.getElementsByName('profile');
                      input.click();

                      //input.addEventListener('change', ()=>  {console.log('onImageUpload')});

                    }}>
                    <ProfilePicture
                      profile={
                        studentProfile.profile_pictures &&
                        studentProfile.profile_pictures["original"]
                      }

                    />
                    <ProfileIcon>
                      <img src="/assets/camara.svg" alt="upload camera" style={{ width: 27, marginTop: -1, marginLeft: -1 }}/>
                    </ProfileIcon>
                    <input type="file" name='profile' style={{ display: "none" }} accept="image/*" onChange={this.onDrop} />
                  </div>
                </ProfilePictureContent>
                <h2 style={{ fontWeight: 400 }}>
                  {student.first_name} {student.last_name_paternal}
                </h2>
                <PillsRow>
                  {infoPills.center && (
                    <Pills>{infoPills.center}</Pills>
                  )}
                  {infoPills.classroom && <Pills>{infoPills.classroom}</Pills>}
                  {infoPills.studyProgram && (
                    <Pills>{infoPills.studyProgram}</Pills>
                  )}
                </PillsRow>
              </CardHeader>
              <StatusBar
                student={student}
                isCloud={
                  student.checkin ? student.checkin.is_virtual_center : false
                }
              />
              {this.renderSections()}
            </PanelContainer>
          </DesktopContainer>
        )}
        {loading ? (
          <PageContainerMobile>
            <Modal isOpened loading />
          </PageContainerMobile>
        ) : (
          <MobileContainer>
            <ProfilePanelMobile {...this.props} infoPills={infoPills} />
          </MobileContainer>
        )}
        <Modal
          isOpened={addSibling}
          headerTitle="Agregar Hermano"
          onClose={this.closeModal}
          allowOverflow
          statePath="addSibling"
          actionType="sending"
          typePrefix="ADD_SIBLING"
        >
          <AddSibling
            enrolledSibling={student}
            parents={student.parents}
            closeModal={this.closeModal}
            loading={addingSibling}
          />
        </Modal>
        <Modal
          isOpened={this.state.addParent}
          headerTitle="Agregar Tutor"
          onClose={() => this.toggleAddParent("close")}
          allowOverflow
          statePath="addParent"
          typePrefix="ADD_PARENT"
        >
          <AddParent
            closeModal={() => this.toggleAddParent("close")}
            studentId={student.id}
          />
        </Modal>
      </Container>
    );
  }
}

ProfilePanel.propTypes = {
  student: PropTypes.object.isRequired,
  classrooms: PropTypes.array,
  studyPrograms: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
  ]),
  /** Returns array of companies in Advenio */
  companies: PropTypes.array.isRequired,
}

ProfilePanel.defaultProps = {
  classrooms: [],
  studyPrograms: [],
}

const mapStateToProps = ({ auth, ...state }) => ({
  addSibling: state.addSibling.sending.fetching,
  classrooms: state.classrooms.get.results,
  center: auth.user.center_id,
  user: auth.user,
  loading: state.companies.get.fetching || state.classrooms.get.fetching,
  companies: state.companies.get.results,
  centroclassroom: state.classrooms.center_id,
  activeStudentId: state.classrooms.activeStudentId,
  studentProfile: Selectors.activeStudent(state),

})

const mapDispatchToProps = dispatch => ({
  goTo: link => dispatch(push(link)),
  setActiveStudentId: id => dispatch(ClassroomActions.setActiveStudentId(id)),
  updateStudent: (activeParentId, profile, timestamp) =>
    dispatch(ClassroomActions.updateStudentRequest(activeParentId, profile, timestamp)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ProfilePanel)



// WEBPACK FOOTER //
// ./src/Components/ProfilePanel/index.jsx